import { AddressType } from "@redotech/redo-model/address-collection";
import { AddressSchema } from "@redotech/redo-model/team";
import * as z from "zod/v4";

export const getAddresses = {
  name: "getAddresses" as const,
  input: z.object({ type: z.enum(AddressType).optional() }),
  output: z.object({ addresses: z.array(AddressSchema) }),
};
